<template>
  <v-sheet>
    <v-card outlined class="marco">
      <v-card-subtitle>
        <h4><strong>{{ $t('page.sectionEditor.early_penalties') }}</strong></h4>
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="formEarlyPenalties">
          <v-row>
            <v-col cols="12" sm="12" xs="12">
              <v-switch
                name="inReaderFlag"
                dense
                class="mt-0"
                v-model="Section.raceSectionChecks[0].inReaderFlag"
                :input-value="Section.raceSectionChecks[0].inReaderFlag"
                :label="$t('page.sectionEditor.useantenna')"
                @change="updateFieldCheck('inReaderFlag', Section.raceSectionChecks[0].inReaderFlag)"
                :true-value="1"
                :false-value="0"
                color="blue"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined
                v-model="Section.raceSectionChecks[0].penalties[0].withoutPenalty"
                @input="updateFieldPenalty('withoutPenalty', Section.raceSectionChecks[0].penalties[0].withoutPenalty)"
                :label="$t('page.sectionEditor.early_without_penalties')"
                :hint="$t('page.sectionEditor.early_without_penalties_lbl')"
                persistent-hint dense
                :rules="formatInvalidRules"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined
                v-model="Section.raceSectionChecks[0].penalties[0].firstMinute"
                @input="updateFieldPenalty('firstMinute', Section.raceSectionChecks[0].penalties[0].firstMinute)"
                :label="$t('page.sectionEditor.first_minute')"
                :hint="$t('page.sectionEditor.first_minute_lbl')"
                persistent-hint dense
                :rules="formatInvalidRules"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined
                v-model="Section.raceSectionChecks[0].penalties[0].nextMinute"
                @input="updateFieldPenalty('nextMinute', Section.raceSectionChecks[0].penalties[0].nextMinute)"
                :label="$t('page.sectionEditor.next_minute')"
                :hint="$t('page.sectionEditor.next_minute_lbl')"
                persistent-hint dense
                :rules="formatInvalidRules"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined
                v-model="Section.raceSectionChecks[0].penalties[0].dsqMinute"
                @input="updateFieldPenalty('dsqMinute', Section.raceSectionChecks[0].penalties[0].dsqMinute)"
                :label="$t('page.sectionEditor.early-disqualification')"
                :hint="$t('page.sectionEditor.early-disqualification-lbl')"
                persistent-hint dense
                :rules="formatInvalidRules"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls], //for api redundant operations
  props: ["Section"],
  components: {},
  data() {
    return {};
  },
  computed: {
    formatInvalidRules() {
      return [ 
        (v) => {
          const value = v ?? '';
          return this.$inputRules({ value }, 'filled') || this.$t('common.field-required')
        },
        (v) => {
          return this.$inputRules({ value: v }, 'nullable') || this.$inputRules({ value: v }, 'integer') || this.$t('common.fomat_invalid_only_number');
        } 
      ];
    },
    Check() {
      return this.Section.raceSectionChecks[0];
    },
    Penalty() {
      return this.Check.penalties[0];
    }
  },
  methods: {
    updateFieldPenalty(field, value) {
      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        penaltyId: this.Penalty.id,
        field,
        value
      };
      this.$store.dispatch('addSectionTimeCheckPenaltyUpdateAction', formData);
    },
    updateFieldCheck(field, value) {
      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        field,
        value
      };
      this.$store.dispatch('addSectionTimeCheckCheckUpdateAction', formData);
    }
  }
};
</script>